/**
 * This component intentionally left blank.
 */
export function FixedDefaultForm() {
  return null;
}
